<template>
    <div class="sso-error">
        <img
            src="@/assets/error/book-airdrop.png"
            alt=""
        >
        <div class="sso-error__message">
            {{ message }}
        </div>
        <div class="sso-error__description" v-if="description">
            {{ description }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { userModule } from '@/store/user/module'

const route = useRoute()

const message = ref('An error has occurred.')
const description = ref('Please try again in a few minutes, or reach out to your admin for help.')

onMounted(() => {
    userModule.actions.signOut()

    if (typeof route.query.errorDescription === 'string') {
        description.value = route.query.errorDescription
    }

    if (typeof route.query.errorMessage === 'string') {
        message.value = route.query.errorMessage
    }
})
</script>

<style lang="scss" scoped>
.sso-error {
    margin: 66px auto;
    max-width: 232px;
    text-align: center;

    img {
        width: 64px;
        height: 92px;
        margin-bottom: 22px;
    }

    &__message {
        font-weight: 600;
        font-size: 15px;
        line-height: 20px;
        margin-bottom: 8px;
    }

    &__description {
        font-weight: 500;
        font-size: 14px;
        line-height: 19px;
    }
}
</style>
